export default __webpack_public_path__ + "static/media/menu-icon.d2548f61.svg";